import { createStore } from 'satcheljs';
import AccessibilityOptionState from './schema/AccessibilityOptionState';
import getPreferAccessibleContentOption from '../../selectors/getPreferAccessibleContentOption';

export default createStore<AccessibilityOptionState>('AccessibilityOptionStore', {
    isEnabled: getPreferAccessibleContentOption(),
});
